import { useRef } from "react";

import Banner from "./Banner";
import JobInformation from "./JobInformation";
import FormSection from "./FormSection";

const JobDetails = () => {
  const applyFormRef = useRef(null);

  return (
    <>
      <div className="bg-white text-gray-800">
        {/* Header */}

        <Banner
          config={{
            applyFormRef,
            title: "JAVA Developer",
          }}
        />

        {/* Content */}
        <div className="bg-white px-6 md:px-16 py-12">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 items-start">
            {/* LEFT SIDE: JOB DESCRIPTION */}

            <div className="lg:col-span-2 space-y-12">
              {/* Job Summary Section */}
              <div>
                <h2 className="text-[32px] font-semibold text-[#212129] mb-6">
                  Job Summary
                </h2>

                <p className="text-[#212129] text-[18px] leading-8 mb-6">
                  We are on the lookout for a self-driven and enthusiastic Java
                  Developer (Fresher) to be part of our backend engineering
                  team. The ideal candidate should have a solid understanding of
                  Java programming fundamentals, object-oriented design, and a
                  willingness to learn and work with modern Java frameworks and
                  tools.
                </p>

                {/* Key Responsibilities */}
                <h3 className="text-[20px] font-semibold text-green-600 mb-1">
                  Key Responsibilities
                </h3>
                <div className="w-[100px] h-[2px] bg-green-600 mb-4" />

                <ul className="list-disc ml-6 space-y-2 text-[#212129] text-[18px] leading-7">
                  <li>
                    Assist in the design, development, and maintenance of
                    Java-based applications.
                  </li>
                  <li>
                    Work with Spring Boot or other Java frameworks to build
                    robust APIs.
                  </li>
                  <li>
                    Collaborate with front-end developers, QA engineers, and
                    designers.
                  </li>
                  <li>Write clean, efficient, and well-documented code.</li>
                  <li>
                    Participate in code reviews and continuous
                    integration/deployment (CI/CD) processes.
                  </li>
                </ul>
              </div>

              {/* Qualifications */}
              <div>
                <h3 className="text-[20px] font-semibold text-green-600 mb-1">
                  Qualifications
                </h3>
                <div className="w-[100px] h-[2px] bg-green-600 mb-4" />

                <ul className="list-disc ml-6 space-y-2 text-[#212129] text-[18px] leading-7">
                  <li>
                    Bachelor’s degree in Computer Science, IT, Engineering, or
                    related field.
                  </li>
                  <li>(Eligible: B.Sc (CS/IT), B.E/B.Tech, BCA, MCA)</li>
                  <li>
                    Strong understanding of core Java and object-oriented
                    programming.
                  </li>
                  <li>
                    Internship or academic project experience in Java
                    development is a plus.
                  </li>
                </ul>
              </div>

              {/* Skills and Competencies */}
              <div>
                <h3 className="text-[20px] font-semibold text-green-600 mb-1">
                  Skills & Competencies
                </h3>
                <div className="w-[100px] h-[2px] bg-green-600 mb-4" />

                <ul className="list-disc ml-6 space-y-2 text-[#212129] text-[18px] leading-7">
                  <li>
                    Proficiency in Java SE and familiarity with Java EE or
                    Spring Boot.
                  </li>
                  <li>
                    Basic knowledge of SQL and relational databases (e.g.,
                    MySQL, PostgreSQL).
                  </li>
                  <li>
                    Understanding of RESTful APIs and backend architecture.
                  </li>
                  <li>
                    Familiarity with tools like Maven, Git, and IDEs like
                    IntelliJ or Eclipse.
                  </li>
                  <li>Strong analytical and logical thinking.</li>
                  <li>Good communication and teamwork skills.</li>
                </ul>
              </div>
            </div>

            {/* RIGHT SIDE: JOB INFORMATION */}
            <JobInformation />
          </div>
        </div>

        {/* Apply Form */}
      </div>

      <FormSection applyFormRef={applyFormRef} />
    </>
  );
};

export default JobDetails;
